import { KiteIcon, KiteMenu, KiteMenuItem } from '@kite/react-kite';
import { ContactSort } from '../../generated/graphql';
import { usePageTranslation } from '../../translation/hooks';
import styles from 'components/contact-list-options/styles/ContactSortOptions.module.scss';
import useURLQueryBuilder from '../common/hooks/useURLQueryBuilder';

interface ContactSortOptionsInterface {
  getContactCollection: (sort: ContactSort) => void;
  selected: ContactSort;
  contactCollectionLoading: boolean;
  contactCollectionFetchError: boolean;
}

interface ContactSortItemInterface {
  query: ContactSort;
  label: string;
  ariaSort: 'ascending' | 'descending';
  event: string;
}

const ContactSortOptions: React.FC<ContactSortOptionsInterface> = ({
  getContactCollection,
  selected,
  contactCollectionLoading,
  contactCollectionFetchError,
}) => {
  const { t } = usePageTranslation('contactActionsCopy');
  const [_searchQueryParam, setSearchQueryParam] = useURLQueryBuilder();

  const sortOptions: ContactSortItemInterface[] = [
    {
      query: ContactSort.DisplayName,
      label: t('sortDisplayName'),
      ariaSort: 'ascending',
      event: 'sortSender',
    },
    {
      query: ContactSort.FirstName,
      label: t('sortFirstName'),
      ariaSort: 'descending',
      event: 'sortNewToOld',
    },
    {
      query: ContactSort.LastName,
      label: t('sortLastName'),
      ariaSort: 'ascending',
      event: 'sortOldToNew',
    },
  ];

  const handleSelectItem = (sortString: ContactSort, event: string): void => {
    // trackEvent({ event });
    setSearchQueryParam('sort', sortString);
    setSearchQueryParam('page', '1');
    getContactCollection(sortString);
  };

  return (
    <div
      className={`${styles.sortOptionsContainer} ${
        contactCollectionLoading || contactCollectionFetchError ? styles.disabled : ''
      }`}
    >
      <KiteMenu
        label={t('sort')}
        variant={'flow'}
        disabled={contactCollectionLoading || contactCollectionFetchError}
        aria-disabled={contactCollectionLoading || contactCollectionFetchError}
        data-id="e2e_sort_button"
      >
        {sortOptions.map((item, index) => {
          const isSelected = selected === item.query;
          return (
            <KiteMenuItem
              key={index}
              className={styles.listItem}
              onClick={() => handleSelectItem(item.query, item.event)}
              aria-sort={item.ariaSort}
            >
              {isSelected ? <KiteIcon icon={'ki-checkmark'} className={styles.checkIcon} /> : <></>}
              <span className={isSelected ? styles.selected : ''}>{item.label}</span>
            </KiteMenuItem>
          );
        })}
      </KiteMenu>
    </div>
  );
};

export default ContactSortOptions;
